import React from 'react';
import { useDispatch } from 'react-redux';
import {
  Box, Typography, FormControlLabel, Switch,
} from '@mui/material';
import { addTabProperty, updateTabProperty, deleteTabProperty } from '../../../actions/apiDealerUpdates';
import {
  PARTS_TAB_PROPERTY_NAME, WORK_ITEM_PARTS_TAB_PROPERTY_NAME, PART_FILES_TAB_PROPERTY_NAME,
} from '../../../components/Parts/partsUtils';

const PLUGINS = [
  { name: PARTS_TAB_PROPERTY_NAME, label: 'Show the vehicle Parts section on this tab', defaultOn: false },
  { name: WORK_ITEM_PARTS_TAB_PROPERTY_NAME, label: 'Show Parts inside each expanded work item on this tab (on by default)', defaultOn: true },
  { name: PART_FILES_TAB_PROPERTY_NAME, label: 'Allow files/photos to be attached to each part row', defaultOn: false },
];

const TabPluginToggles = ({ tab }) => {
  const dispatch = useDispatch();
  const properties = tab?.tab_properties || [];

  const isEnabled = (name, defaultOn) => {
    const p = properties.find(x => x.name === name);
    if (!p) return defaultOn;
    return String(p.value) !== 'false';
  };

  const toggle = (name, defaultOn, checked) => {
    const existing = properties.find(p => p.name === name);
    if (defaultOn) {
      if (checked) {
        if (existing) dispatch(deleteTabProperty(existing.id, 'deleteTabProperty'));
      } else if (existing) {
        dispatch(updateTabProperty(existing.id, { value: 'false' }, 'updateTabProperty'));
      } else {
        dispatch(addTabProperty({ tab_id: tab.id, name, value: 'false' }, 'addTabProperty'));
      }
    } else if (checked) {
      if (existing) dispatch(updateTabProperty(existing.id, { value: 'true' }, 'updateTabProperty'));
      else dispatch(addTabProperty({ tab_id: tab.id, name, value: 'true' }, 'addTabProperty'));
    } else if (existing) {
      dispatch(deleteTabProperty(existing.id, 'deleteTabProperty'));
    }
  };

  if (!tab?.id) return null;

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>Tab Components</Typography>
      {PLUGINS.map(plugin => (
        <FormControlLabel
          key={plugin.name}
          control={(
            <Switch
              checked={isEnabled(plugin.name, plugin.defaultOn)}
              onChange={e => toggle(plugin.name, plugin.defaultOn, e.target.checked)}
            />
          )}
          label={plugin.label}
        />
      ))}
    </Box>
  );
};

export default TabPluginToggles;
